<sc-padding class="no-field-space">

  <ac-string-property propertyKey="tmc-yard.terminal.allowed-registration-before-planningdate"></ac-string-property>
  <ac-string-property propertyKey="tmc-yard.terminal.allowed-registration-after-planningdate"></ac-string-property>
  <ac-string-property propertyKey="tmc-yard.terminal.language-selection-card-size"></ac-string-property>
  <ac-string-property propertyKey="tmc-yard.terminal.allowed-countries-phonenumberfield"></ac-string-property>
  <sc-hint-legacy dictionaryKey="tmc-yard.terminal.ui.terminal-property-administration.countries-phonenumberfield-hint"></sc-hint-legacy>

  <ac-boolean-property propertyKey="tmc-yard.terminal.autoselect-single-transportoption"></ac-boolean-property>
  <ac-boolean-property propertyKey="tmc-yard.terminal.skip-transportoption-selection-if-exists"></ac-boolean-property>

  <sc-content-spacer vertical double></sc-content-spacer>

  <sc-sub-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.terminal.ui.terminal-property-administration.notification-types"></sc-dictionary-label>
  </sc-sub-title>

  <sc-hint-legacy dictionaryKey="tmc-yard.terminal.ui.terminal-property-administration.notification-types-hint"></sc-hint-legacy>
  <sc-hint-legacy dictionaryKey="tmc-yard.terminal.ui.terminal-property-administration.possible-notification-types-hint"></sc-hint-legacy>
  <ul>
    <li>LIST - Anzeige in der Nachrichtenliste</li>
    <li>SNACKBAR - Anzeige als Überblendung</li>
  </ul>
  <ac-string-property propertyKey="tmc-yard.terminal.notification-relevance-transport-truck"></ac-string-property>
  <ac-string-property propertyKey="tmc-yard.terminal.notification-relevance-visitor"></ac-string-property>

  <sc-content-spacer vertical double></sc-content-spacer>

  <sc-sub-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.terminal.ui.terminal-property-administration.transport-without-routing"></sc-dictionary-label>
  </sc-sub-title>
  <ac-boolean-property propertyKey="tmc-yard.terminal.choose-target-station-for-transport-without-routing"></ac-boolean-property>
  <ac-boolean-property propertyKey="tmc-yard.terminal.send-sms-with-target-station"></ac-boolean-property>

</sc-padding>